var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar-sidebar bg-white p-3 mr-3 shadow-sm rounded"},[_c('h6',{staticClass:"text-secondary"},[_vm._v("Empleados")]),_vm._t("filter")],2)}
var staticRenderFns = []

export { render, staticRenderFns }